import { BlockReducer } from 'components/admin/custom-blocks/block-reducer';
import { KeyValueBlock } from 'components/admin/custom-blocks/key-value';
import gql from 'graphql-tag';
import { useReducer } from 'react';
import { useGetAlertsQuery, useAddAlertMutation } from 'lib/graphql-generated';
import { Spinner } from 'components/spinner';
import { BlockType, ContentBlock } from 'components/admin/custom-blocks/types';
import { Button } from 'components/buttons/button';
import { saveDraftContent } from 'components/text-editor/editor-utils';

const GET_ALERTS = gql`
  query GetAlerts {
    unstructured_data_by_pk(title: "alert") {
      data
      title
    }
  }
`;

const ADD_ALERT = gql`
  mutation AddAlert($data: jsonb) {
    update_unstructured_data_by_pk(
      pk_columns: { title: "alert" }
      _set: { data: $data }
    ) {
      data
    }
  }
`;

export const AlertSection = () => {
  const [content, dispatch] = useReducer(BlockReducer, {
    isModified: false,
    isInit: false,
    data: [],
  });

  const { data, loading, refetch } = useGetAlertsQuery({
    onCompleted: (data) => {
      if (!!data?.unstructured_data_by_pk) {
        dispatch({
          type: 'init',
          payload: {
            data: data.unstructured_data_by_pk.data,
          },
        });
      }
    },
  });

  const [save, { loading: saving }] = useAddAlertMutation();

  const handleSave = (e) => {
    e.preventDefault();
    save({
      variables: {
        data: content.data.map((block) => {
          let typedBlock = block as ContentBlock<'key-value'>;
          return {
            ...typedBlock,
            data: typedBlock.data.map((ob) => ({
              key: ob.key,
              value: saveDraftContent(ob.value),
            })),
          };
        }),
      },
    }).then(() => {
      refetch().then(({ data }) => {
        if (!!data?.unstructured_data_by_pk) {
          dispatch({
            type: 'init',
            payload: {
              data: data.unstructured_data_by_pk.data,
            },
          });
        }
      });
    });
  };

  return (
    <article className='bg-white shadow rounded-md  py-6 px-4 sm:p-6'>
      <header className=''>
        <h2 className='header text-xl text-gray-900'>Alerts</h2>
        <p className='mt-1 text-sm text-gray-500'>
          Alert banners that appear at the top of the website. Don't set too
          many or it'll get ugly. Fast.
        </p>
      </header>
      {loading ? (
        <Spinner />
      ) : !!data?.unstructured_data_by_pk ? (
        <form action='' className='mt-6 grid grid-cols-4 gap-6'>
          {content.data.map((block, index) => (
            <KeyValueBlock
              hideTitle
              keyLabel='Title'
              valueLabel='Alert'
              key={index}
              reducer={dispatch}
              block={block as ContentBlock<'key-value'>}
              className='col-span-full w-full'
            />
          ))}
          <section className='col-span-full'>
            <Button
              buttonType='primary'
              disabled={!content.isModified || saving}
              onClick={handleSave}>
              Save
            </Button>
          </section>
        </form>
      ) : null}
    </article>
  );
};
